import { EvtHeader } from "components/header";
import React from "react";
import FunctionForm from "../form";

const CreateFunction = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Function" />
      <div className="p-6 max-w-2xl">
        <FunctionForm />
      </div>
    </div>
  );
};

export default CreateFunction;
